import { PermissionT } from "../types";

export const userImpersonate = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "impersonate_user");
  return !!p && !!p?.actions?.includes("impersonate");
};

export default userImpersonate;
